import Config from '@/config.json'
import store from '@/store/index'

const getBCName = () => {
  try {
    const instanceNameFromConfig =
      Config?.VUE_APP_CAS_URL_SHORT || window.location.origin
    const instanceName =
      instanceNameFromConfig && typeof instanceNameFromConfig === 'string'
        ? instanceNameFromConfig
        : window.location.origin
    const bc_domainWithPath = instanceName.split('://')
    let bc_domain = bc_domainWithPath[1].split('/')[0]
    if (typeof bc_domain !== 'string') {
      bc_domain = ''
    }
    const bc_transformedDomain = bc_domain.replaceAll('.', '-')
    if (bc_transformedDomain && bc_transformedDomain !== '') {
      return `bhas-${bc_transformedDomain}`
    }
    return `bhas-all-bh-instances`
  } catch {
    return 'bhas-all-bh-instances'
  }
}

const bcName = getBCName() || 'bhas-all-bh-instances'

const bc = new BroadcastChannel(bcName)

class Broadcast {
  constructor() {}

  async logout() {
    store.commit('userStates/updateToken', null)
    store.commit('userStates/updateRefreshToken', null)
    store.commit('userStates/updateProfileId', null)
    store.commit('userStates/updateUserTenant', null)
    store.commit('userStates/updateUserFeatureFlags', {})
    store.commit('userStates/updateLoggedIn', false)
    store.commit('userStates/updateUser', {})

    window.location.href = `${Config?.VUE_APP_WEB_URL ||
      window?.location?.origin}`
  }

  initialize() {
    // do nothing
  }
}

let BroadcastService = new Broadcast()

const updateStatus = reqData => {
  const {
    action,
    // data,
  } = reqData
  switch (action) {
    case 'LOGOUT':
      BroadcastService.logout()
      break
    default:
    // do nothing
  }
}

bc.onmessage = e => {
  const { action, data } = e.data

  updateStatus({ action, data })
}

const triggerLogoutInAllTabs = () => {
  bc.postMessage({
    action: 'LOGOUT',
    data: null,
  })
}

export { BroadcastService, triggerLogoutInAllTabs }
